import React from 'react';
import { useTranslation } from 'react-i18next';

import { ISuppliers } from '@/modules/workforce/Crew/types';
import { Avatar, NextImage, Typography } from '@/shared/components/atoms';

import Gallary from '~/images/shared/gallery.svg';

interface IProps {
  identityInfo?: ISuppliers.IIdentityInfo;
}
export function IdentityInfo({ identityInfo }: IProps) {
  const { t } = useTranslation('common');
  /************************************* api ************************************ */

  return (
    <div className='rounded-xl bg-white p-16'>
      <Typography weight='bold' variant='subtitle' className='mb-16'>
        {t('identity-info')}
      </Typography>
      <div className='flex justify-between'>
        <div className='grid grid-cols-2 gap-64'>
          <IdentityInfoRow
            label={t('id-number')}
            value={identityInfo?.nationalIdNumber}
          />
        </div>
        <div className='flex gap-16 '>
          <IDImage
            notFoundText={t('there-is-no-photo-for-front-id')}
            src={identityInfo?.nationalIdFront}
          />
          <IDImage
            notFoundText={t('there-is-no-photo-for-back-id')}
            src={identityInfo?.nationalIdBack}
          />
        </div>
      </div>
    </div>
  );
}

const IdentityInfoRow = ({
  label,
  value,
}: {
  label: string;
  value?: string | number;
}) => {
  return (
    <div className=''>
      <Typography variant='body2' className='mb-8 capitalize text-text-600'>
        {label}
      </Typography>
      <Typography variant='body1' weight='medium'>
        {value || '-'}
      </Typography>
    </div>
  );
};

const IDImage = ({
  src,
  notFoundText,
}: {
  src?: string | null;
  notFoundText?: string | number;
}) => {
  return src ? (
    <div className='h-200 w-343 overflow-hidden rounded-xl'>
      <NextImage
        src={src || ''}
        alt='not found'
        fill
        className='h-full w-full '
      />
    </div>
  ) : (
    <div className='flex flex-col items-center justify-center rounded-xl bg-primary-99 px-56 py-24'>
      <Avatar size='2xl' icon={<Gallary className />} className='bg-blue-100' />
      <Typography variant='body1' weight='medium'>
        {notFoundText || '-'}
      </Typography>
    </div>
  );
};
